import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const subscriptionRoutesDictionary = moduleRouteDictionaryFactory(
  'subscription',
  'subscriptions',
  {
    list: 'list',
  },
);
